<template>

<section  class="navbarsection" style="margin-top: -50px;">
      <div class="txtdata">
        <h1  style="padding-top: 200px;"></h1>
      </div>
        <div class="videosection" >
          <div  v-show="pvisvideo === true && pvpictureimage === false ">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.2
                :src="src"
                :poster="poster"
                :class="`thing playercss`"
                :style="`height: 600px;`">
              </video-background>
            </Transition>
          </div>
        
            <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
            </div>
  
            <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
            v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
   
      </div>
      <div class="overlay"></div>
      <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
        <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
      </div>
    </section>

  <section class="topsection">
    <div class="topcontainer">
      <div v-html="topinfo" class="col-xs-12 col-sm-12 col-md-12">
      </div>
    </div>
  </section>
   

    <section class="tabsandtextdivcss">
      <div class="innertabdiv">
        <TabsandTextcards :allcodes="allcodes" :allcodesdetails="allcodedetails" :getdtsInfo="getdtsInfo" @click.prevent="getdtsId($event)" :getfirstid="allcodedetails" />
      </div>
    </section>



      <div v-html="bottominfo" class="bottomcontainer"></div>



</template>

<script>

import TabsandTextcards from '@/components/TabsandTextcards.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
import axios from 'axios';


export default {
  name: 'AboutView',
  components: {
  TabsandTextcards
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  pvwebm: '',
  pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,

  getdtsInfo: '',
  getfirstid: '',
  allcodesingle: '',
  allcodes: [],
  allcodedetails: [],
  valuelisting2: [],
  valueid: 0,

  shortdesc: '',
  topinfo: '',
  bottominfo: ''
  }
},
methods: {

},
async mounted() {

await axios.get('allpagespv/portfolio').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1


      if (this.pvisvideo === 'true') {
        this.src = this.videoimage.pvmp4
        this.showVideo
        if (response.status === 403 ) {
        e = "No data available"
        const toast = useToast();
        toast.success(e, {
        timeout: 6000
        });
        }
        else if (response.status === 404) {
          e = "Page Not Found!"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
        });
        }
      }
      else{
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
      }
      console.log(this.src)
  })
  .catch((error) => {
          console.log(error)
        })

  //get all portfolio information
  //-----------All codes -------------
    await axios.get('getportfolioinfo/').then(
    response => {
      this.shortdesc = response.data[0].shortdesc
        this.topinfo = response.data[0].topinfo
        this.bottominfo = response.data[0].bottominfo
        console.log(this.shortdesc)
  })
  .catch((error) => {
      console.log(error)
    })   
  
  //-----------All codes -------------
  await axios.get('getallcodes/portfolio').then(
      response => {
        this.allcodes = response.data
    })
    .catch((error) => {
        console.log(error)
      })

  

    //-----------All codes Single -------------
   await axios.get(`getallcodes/portfolio`).then(
      response => {
        this.allcodesingle = response.data[0].oportid
        console.log(this.allcodesingle)
        
        axios.get(`getallcodesdetails/${this.allcodesingle}`).then(
          response => {
            this.allcodedetails = response.data[0].portdetails
              console.log(response.data)
          })
          .catch((error) => {
              console.log(error)
            })
          })
    .catch((error) => {
        console.log(error)
      })
},
methods: {
    async getdtsId(event) {
      let diid = parseInt(event.target.value)
      console.log(diid)
      await axios.get(`getallcodesdetails/${diid}`).then(
      response => {
        this.getdtsInfo = response.data[0].portdetails
    })
    .catch((error) => {
        console.log(error)
      })
    }
}
}
</script>

<style scoped>
.section03 {
  height: 300px;
}
.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}
.tabsandtextdivcss {
  margin-top: 500px;
}

.bottomsection {
  height: 200px;
  margin-bottom: 100px;
  padding-bottom: 100px;
 }

 .topsection {
   margin-top: 150px;
   margin-bottom: -300px;;
   height: 100px;

 }



.topcontainer{
  width: 100%;
}
.bottomcontainer {
  width: 90%;
  text-align: justify;
  padding-left: 100px;
  padding-right: 100px;
  padding-bottom: 100px;
}
.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
/* Move the background and make it larger. 
/* Media Query CSS*/
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
 
   .bottomcontainer {
    width: 90%;
    text-align: justify;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 100px;
  }
  .topcontainer {
    text-align: justify;
    padding-left: 20px;
    padding-right: 20px;
  }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
 
  .bottomcontainer {
    width: 90%;
    text-align: justify;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 100px;
  }
  .topcontainer {
    text-align: justify;
    padding-left: 20px;
    padding-right: 20px;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
 
  .bottomcontainer {
    width: 90%;
    text-align: justify;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 100px;
  }
  .topcontainer {
    text-align: justify;
    padding-left: 40px;
    padding-right: 40px;
  }
 }
 

 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
 
  .bottomcontainer {
    width: 100%;
    text-align: justify;
    padding-left: 120px;
    padding-right: 120px;
    padding-bottom: 100px;
  }
  .topcontainer {
    text-align: justify;
    padding-left: 120px;
    padding-right: 120px;
  }
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
 

 } 

 @media only screen and (min-width: 1400px) {

  }
@media only screen and (min-width: 1600px) {


 } 
</style>
